import {
  onFilesChange,
  onPreUploadFileChange,
  onCurrFileChange,
  onUploadAgainFileChange,
} from './files';
import {
  onFileListModalChange,
  onTokenIdChange,
  onHandleImgErrChange,
  onUserActionChange,
  onAuthorizationChange,
  onPurchaseModalObjChange,
  onProfileObjChange,
  onSubscriptionChange,
  onVideoEditorTimesChange,
  onImageCutoutTimesChange,
  openAdvertiseDialog,
  advertiseConfig,
  downloadPercent,
  hideLink,
  onPayBill,
  onExceed2M,
  onSaveSku,
  onSaveSwitchOther,
  onPayTrigger,
  onSignUpModal,
  loginIn,
  loginOut,
  sendVerification,
  signUpEmail,
  saveEmail,
} from './common';
import {
  onWorkChange,
  onUploadingChange,
  onUploadPercentChange,
  onProcessPercentChange,
  onProcessStepChange,
  onCurrProgressChange,
  onStartTimeChange,
  onCancelProgressChange,
  onFileToBlobStatusChange,
  onSubmittingChange,
  onUploadXHRChange,
  onFetchAbortChange,
  onToGifObjChange,
  onCropChange,
  onAudioCompressListChange,
  onAudioExtractorFileChange,
  onAudioJoinerListChange,
  onAudioCutSpeedVolumeObjChange,
  onAudioAddMusicListChange,
  onVideoCompressObjChange,
  onVideoMuteObjChange,
  onImageCutoutObjChange,
} from './work';

export default {
  onFilesChange,
  onWorkChange,
  onFileListModalChange,
  onProcessPercentChange,
  onTokenIdChange,
  onPreUploadFileChange,
  onUploadingChange,
  onUploadPercentChange,
  onProcessStepChange,
  onHandleImgErrChange,
  onCurrProgressChange,
  onStartTimeChange,
  onCurrFileChange,
  onCancelProgressChange,
  onUserActionChange,
  onAuthorizationChange,
  onFileToBlobStatusChange,
  onSubmittingChange,
  onUploadAgainFileChange,
  onUploadXHRChange,
  onFetchAbortChange,
  onToGifObjChange,
  onCropChange,
  onAudioCompressListChange,
  onAudioExtractorFileChange,
  onAudioJoinerListChange,
  onAudioCutSpeedVolumeObjChange,
  onAudioAddMusicListChange,
  onVideoCompressObjChange,
  onVideoMuteObjChange,
  onImageCutoutObjChange,
  onPurchaseModalObjChange,
  onProfileObjChange,
  onSubscriptionChange,
  onVideoEditorTimesChange,
  onImageCutoutTimesChange,
  openAdvertiseDialog,
  advertiseConfig,
  downloadPercent,
  hideLink,
  onPayBill,
  onExceed2M,
  onPayTrigger,
  onSaveSku,
  onSaveSwitchOther,
  onSignUpModal,
  loginIn,
  sendVerification,
  loginOut,
  signUpEmail,
  saveEmail,
};
